<div class="modal-content">
  <div class="modal-header text-center">
    <span class="modal-pre-contrato__title">EMISSÃO DO PRÉ-CONTRATO</span>
  </div>
  <div class="modal-body text-center" [formGroup]="formTipoAssinatura">
    <div class="modal-pre-contrato__text">
      <h4>Tipo de Assinatura</h4>
      <span>Como seu cliente deseja assinar estes documentos?</span>
    </div>
    <div class="modal-pre-contrato__itens">
      <div
        class="modal-pre-contrato__item check-mod"
        (click)="onChangeTipoAssinatura(tipo)"
        *ngFor="let tipo of listTipoAssinatura"
      >
        <input
          type="radio"
          formControlName="tipoAssinatura"
          [id]="tipo.id"
          [value]="tipo.id"
        />
        <label [for]="tipo.id">
          <span>
            {{ tipo.descricao }}
          </span>
        </label>
      </div>
    </div>

    <section *ngIf="tipoAssinatura === 2">
      <div class="modal-pre-contrato__text">
        <h4>Envio da Assinatura Eletrônica</h4>
        <span
          >Como seu cliente deseja <strong>receber</strong> estes
          documentos?</span
        >
      </div>
      <div
        class="modal-pre-contrato__option"
        [ngClass]="{
          'modal-pre-contrato__option_checked': tipo.id === tipoEnvio
        }"
        (click)="onChangeTipoEnvio(tipo)"
        *ngFor="let tipo of listTipoEnvio"
      >
        <div class="modal-pre-contrato__option_text">
          <label [for]="tipo.id">
            {{ tipo.descricao }}
          </label>
          <span>
            {{ tipo.detalhe1 }} <br />
            <span class="modal-pre-contrato__option_highlight">
              {{ tipo.id === 1 || tipo.id === 3 ? celular : email }}
            </span>
            {{ tipo.detalhe2 }}
          </span>
        </div>
        <input
          type="radio"
          formControlName="tipoEnvio"
          [id]="tipo.id"
          [value]="tipo.id"
        />
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <div class="modal-pre-contrato__action">
      <button type="button" class="btn btn-app btn-secondary" (click)="close()">
        Voltar
      </button>

      <button
        type="button"
        class="btn btn-app btn-primary"
        [disabled]="!formValid"
        (click)="emitirPreContrato()"
      >
        Emitir Pré-Contrato
        <!-- TODO:Retornar depois e trocar o método para checkTipoAssinatura-->
        <!-- <span *ngIf="!loadingCheckData">Emitir Pré-Contrato</span>
        <app-loading *ngIf="loadingCheckData"></app-loading> -->
      </button>
    </div>
  </div>
</div>

<app-loader-circles *ngIf="isLoading"></app-loader-circles>
